import * as React from "react";
import { WifiOff } from "lucide-react";
import { usePlatform } from "@/platform/usePlatform";

export function OfflineBanner(): React.ReactElement | null {
  const { isOnline } = usePlatform();
  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 bg-[color:var(--warning)] px-4 py-2 text-sm font-medium text-white"
    >
      <WifiOff size={14} aria-hidden />
      <span>No internet connection — showing cached data</span>
    </div>
  );
}
